
import axios from 'axios';
import {backendHost} from '../../../../store/config';

export const updateClientId = (params) => {
    return axios.put(`${backendHost}/api/admin/user/change-clientid`, params);
};